import styled from 'styled-components';

export const SvgIconContainer = styled.div`
    visibility: ${props => props.show ? 'visible' : 'hidden'};
    opacity: ${props => props.show ? 1 : 0};
    position: absolute;
    left: ${props => props.leftOffset ? props.leftOffset : 0};
    top: 0;
    transition: opacity 0.25s;
`